/* Faborange Custom JS - Speed Optimized */

/* ---- SLICK SAFE INIT PATTERN ---- */
/* All slick calls go through this wrapper - ensures jQuery + Slick are both ready */
function initSliders() {
  var prevArrowHtml = '<button class="prev-arrow"><svg width="12" height="10" viewBox="0 0 406 331" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M340 331H406L246.5 167.5L406 3H340L181.5 167L340 331Z" fill="#CEA65A"/><path d="M159 331H225L65.5 167.5L225 3H159L0.5 167L159 331Z" fill="#CEA65A"/></svg></button>';
  var nextArrowHtml = '<button class="next-arrow"><svg width="12" height="10" viewBox="0 0 406 331" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M66 331H0L159.5 167.5L0 3H66L224.5 167L66 331Z" fill="#CEA65A"/><path d="M247 331H181L340.5 167.5L181 3H247L405.5 167L247 331Z" fill="#CEA65A"/></svg></button>';

  /* Video section slider */
  if ($(".cstm-video-section-content").length && !$(".cstm-video-section-content").hasClass("slick-initialized")) {
    $(".cstm-video-section-content").slick({slidesToShow:4.3,slidesToScroll:1,infinite:false,prevArrow:prevArrowHtml,nextArrow:nextArrowHtml,responsive:[{breakpoint:991,settings:{slidesToShow:3.2}},{breakpoint:767,settings:{slidesToShow:1.6,centerPadding:"35px"}}]});
  }

  /* Desktop collection slider */
  if ($(window).width() > 768 && $(".enable_slider_desktop").length && !$(".enable_slider_desktop").hasClass("slick-initialized")) {
    $(".enable_slider_desktop").slick({infinite:true,slidesToShow:5,slidesToScroll:1,prevArrow:prevArrowHtml,nextArrow:nextArrowHtml});
  }

  /* Home switch slider */
  if ($(".home_switch_cstm_slider").length && !$(".home_switch_cstm_slider").hasClass("slick-initialized")) {
    $(".home_switch_cstm_slider").slick({slidesToShow:4.3,slidesToScroll:1,variableWidth:true,dots:true,infinite:false,prevArrow:prevArrowHtml,nextArrow:nextArrowHtml,responsive:[{breakpoint:768,settings:{arrows:false,slidesToShow:2,slidesToScroll:1}},{breakpoint:550,settings:{arrows:false,slidesToShow:1,slidesToScroll:1}}]});
  }

  /* Review slider */
  if ($(".custom-review-nav").length && !$(".custom-review-nav").hasClass("slick-initialized")) {
    $(".custom-review-nav").slick({slidesToShow:3,infinite:true,slidesToScroll:1,autoplay:true,autoplaySpeed:3000,dots:false,prevArrow:prevArrowHtml,nextArrow:nextArrowHtml,responsive:[{breakpoint:991,settings:{slidesToShow:2}},{breakpoint:767,settings:{slidesToShow:1}}]});
  }

  /* Marquee slider */
  if ($(".cstm-marquee").length && !$(".cstm-marquee").hasClass("slick-initialized")) {
    $(".cstm-marquee").slick({dots:false,infinite:true,speed:3500,slidesToShow:1,slidesToScroll:1,autoplay:true,autoplaySpeed:0,arrows:false,cssEase:"linear",pauseOnHover:false,variableWidth:true,responsive:[{breakpoint:768,settings:{arrows:false,slidesToShow:4}},{breakpoint:480,settings:{arrows:false,slidesToShow:4,infinite:true,autoplay:true}}]});
  }

  /* Upsell slider */
  if ($(".upsell_prod_wrap").length && !$(".upsell_prod_wrap").hasClass("slick-initialized")) {
    $(".upsell_prod_wrap").slick({infinite:true,slidesToShow:1,slidesToScroll:1,autoplay:true,prevArrow:prevArrowHtml,nextArrow:nextArrowHtml});
  }

  /* Partner grid slider */
  if ($(".partner-grid").length) {
    $(".partner-grid").each(function() {
      if (!$(this).hasClass("slick-initialized")) {
        $(this).slick({dots:false,arrows:true,infinite:true,autoplay:true,autoplaySpeed:2000,speed:500,slidesToShow:8,variableWidth:true,slidesToScroll:1,prevArrow:prevArrowHtml,nextArrow:nextArrowHtml,responsive:[{breakpoint:767,settings:{slidesToShow:2,slidesToScroll:1,arrows:true,autoplay:true,autoplaySpeed:2000}}]});
      }
    });
  }
}

/* ---- VIDEO MODAL LOGIC ---- */
function initVideoModal() {
  var modal = $("#customModal");
  var closeBtn = $(".close-button");

  function playCurrentVideo(slider) {
    var idx = slider.slick("slickCurrentSlide");
    var vid = slider.find('.slick-slide[data-slick-index="' + idx + '"] video').get(0);
    if (vid) { vid.muted = false; vid.play().catch(function(e){ console.error("Playback error:", e); }); }
  }

  $(".videos_wrapper_cstm video").on("click", function() {
    modal.css({display:"block",zIndex:999});
    $("body").css("overflow","hidden");
    modal.attr("aria-hidden","false");
    var idx = $(".videos_wrapper_cstm video").index(this);
    var modalSlider = $(".modal-video-section-content");
    if (!modalSlider.hasClass("slick-initialized")) {
      var prevArrowHtml = '<button class="prev-arrow"><svg width="12" height="10" viewBox="0 0 406 331" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M340 331H406L246.5 167.5L406 3H340L181.5 167L340 331Z" fill="#CEA65A"/><path d="M159 331H225L65.5 167.5L225 3H159L0.5 167L159 331Z" fill="#CEA65A"/></svg></button>';
      var nextArrowHtml = '<button class="next-arrow"><svg width="12" height="10" viewBox="0 0 406 331" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M66 331H0L159.5 167.5L0 3H66L224.5 167L66 331Z" fill="#CEA65A"/><path d="M247 331H181L340.5 167.5L181 3H247L405.5 167L247 331Z" fill="#CEA65A"/></svg></button>';
      modalSlider.slick({slidesToShow:1,slidesToScroll:1,prevArrow:prevArrowHtml,nextArrow:nextArrowHtml});
      modalSlider.on("afterChange", function(e, slick, currentSlide) {
        $(".modal_videos_wrapper_cstm video").each(function(){ this.pause(); this.currentTime=0; this.muted=true; });
        playCurrentVideo(modalSlider);
      });
    }
    modalSlider.slick("slickGoTo", idx, true);
    setTimeout(function(){ playCurrentVideo(modalSlider); }, 300);
  });

  closeBtn.on("click", function() {
    modal.hide();
    $("body").css("overflow","");
    modal.attr("aria-hidden","true");
    $(".modal_videos_wrapper_cstm video").each(function(){ this.pause(); this.currentTime=0; this.muted=true; });
  });

  $(window).on("click", function(e) {
    if ($(e.target).is(modal)) closeBtn.trigger("click");
  });
}

/* ---- CART FUNCTIONS ---- */
function updateCartCount() {
  $.getJSON("/cart", function(cart) {
    if (cart.item_count > 0) {
      $(".cart-count-bubble span").text(cart.item_count).show();
    } else {
      $(".cart-count-bubble").hide();
    }
  });
}

function updateCartDrawer() {
  $.ajax({
    type:"GET", url:"/?section_id=cart-drawer",
    success: function(response) {
      var updatedHTML = $(response).find("cart-drawer").html();
      if (updatedHTML) $("cart-drawer").removeClass("is-empty").html(updatedHTML);
    }
  });
}

/* ---- UPSELL BUTTON ---- */
$(document).on("click", ".upsell_prod .upsell_btn", function() {
  var $btn = $(this), $spinner = $btn.find(".loading__spinner");
  $btn.css("opacity","0.6").prop("disabled",true);
  $spinner.removeClass("hidden").fadeIn(200);
  var cartselector = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
  var item = { id: $btn.attr("data-var-upsellid"), quantity:1, sections: cartselector.getSectionsToRender().map(function(s){return s.id;}) };
  $.ajax({
    type:"post", url:"/cart/add.js", data:item, dataType:"json",
    success: function(resp) { $(cartselector).removeClass("is-empty"); cartselector.renderContents(resp); },
    complete: function() { $spinner.fadeOut(200, function(){ $(this).addClass("hidden"); $btn.css("opacity","1").prop("disabled",false); }); }
  });
  return false;
});

/* ---- CART UPSELL (cart drawer) ---- */
$(document).on("click", ".cart_upsell.button", function() {
  var $btn = $(this), $spinner = $btn.find(".loading__spinner");
  $btn.css("opacity","0.6").prop("disabled",true);
  $spinner.removeClass("hidden").fadeIn(200);
  var cartselector = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
  var item = { id: $btn.attr("data-cartupsell"), quantity:1, sections: cartselector.getSectionsToRender().map(function(s){return s.id;}) };
  $.ajax({
    type:"post", url:"/cart/add.js", data:item, dataType:"json",
    success: function(resp) { cartselector = document.querySelector("cart-notification") || document.querySelector("cart-drawer"); cartselector.renderContents(resp); },
    complete: function() { $spinner.fadeOut(200, function(){ $(this).addClass("hidden"); $btn.css("opacity","1").prop("disabled",false); }); }
  });
  return false;
});

/* ---- ATC STICKY BUTTON ---- */
var stickyBtn = document.querySelector(".sticky-atc.product-form .product-form__buttons .product-form__submit");
if (stickyBtn) {
  var spinner = stickyBtn.querySelector(".loading__spinner");
  var mainBtn = document.querySelector(".product-form .product-form__submit");
  stickyBtn.addEventListener("click", function(e) {
    e.preventDefault();
    if (!mainBtn) return;
    if (spinner) spinner.classList.remove("hidden");
    stickyBtn.style.opacity = "0.6";
    stickyBtn.disabled = true;
    mainBtn.click();
  });
  if (typeof subscribe !== "undefined") {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function() {
      if (spinner) spinner.classList.add("hidden");
      stickyBtn.style.opacity = "1";
      stickyBtn.disabled = false;
    });
  }
}

/* ---- CUSTOM ATC BUTTON ---- */
$(document).on("click", ".cstm_atc_btn", function(e) {
  e.preventDefault();
  var productId = $(this).data("var-id-cstm");
  $.ajax({
    type:"POST", url:"/cart/add.js", data:{id:productId,quantity:1}, dataType:"json",
    success: function() { updateCartCount(); updateCartDrawer(); $(".drawer").addClass("active"); }
  });
});

/* ---- MENU DRAWER ---- */
$(document).on("click", ".child_drawer_menu_custom", function() {
  var menuDrawer = document.querySelector("#menu-drawer");
  var navigation = document.querySelector(".menu-drawer__navigation");
  $(this).closest(".menu-drawer__inner-container").addClass("cstm_child_new_menu");
  if (menuDrawer) {
    menuDrawer.style.setProperty("overflow-y","hidden","important");
    if (navigation) { var h = navigation.scrollHeight+280; menuDrawer.style.height=h+"px"; menuDrawer.style.maxHeight=h+"px"; }
  }
});

$(document).on("click", ".back_to_child .back_cstm_wrapper", function() {
  var menuDrawer = document.querySelector("#menu-drawer");
  $(this).closest(".menu-drawer__inner-container").removeClass("cstm_child_new_menu");
  if (menuDrawer) { menuDrawer.style.setProperty("overflow-y","auto","important"); menuDrawer.style.height=""; menuDrawer.style.maxHeight=""; }
});

/* ---- COLLECTION LIST CHILD PANEL ---- */
document.addEventListener("DOMContentLoaded", function() {
  /* Fix menu text dashes */
  document.querySelectorAll(".menu-mobile_drawer p").forEach(function(p){ p.textContent = p.textContent.replace(/-/g," "); });

  /* Product meta active link */
  var currentPath = window.location.pathname;
  document.querySelectorAll(".prod_meta_list").forEach(function(link) {
    if (link.getAttribute("href") === currentPath) {
      link.classList.add("active");
      link.addEventListener("click", function(e){ e.preventDefault(); });
    }
  });

  /* Collection list trigger */
  document.querySelectorAll(".child_coll_list_trigger").forEach(function(trigger) {
    trigger.addEventListener("click", function() {
      var menuType = this.getAttribute("data-menu-type");
      var collWrap = document.querySelector(".collection_list_wrapper");
      var prodWrap = document.querySelector(".product_list_wrapper");
      if (menuType === "collection") { if(collWrap) collWrap.style.display="grid"; if(prodWrap) prodWrap.style.display="none"; }
      else { if(collWrap) collWrap.style.display="none"; if(prodWrap) prodWrap.style.display="grid"; }

      /* Panel slide */
      var panel = document.querySelector(".has_coll_list_child");
      var menuDrawer = document.querySelector("#menu-drawer");
      if (panel) panel.classList.add("coll_panel_active");
      if (menuDrawer) { menuDrawer.style.overflowY="hidden"; setDrawerHeight(); }
    });
  });

  var backBtn = document.querySelector(".back_coll_list");
  if (backBtn) {
    backBtn.addEventListener("click", function() {
      var panel = document.querySelector(".has_coll_list_child");
      var menuDrawer = document.querySelector("#menu-drawer");
      if (panel) panel.classList.remove("coll_panel_active");
      if (menuDrawer) { menuDrawer.style.overflowY="auto"; menuDrawer.style.height=""; menuDrawer.style.maxHeight=""; }
    });
  }

  function setDrawerHeight() {
    var navigation = document.querySelector(".menu-drawer__navigation");
    var menuDrawer = document.querySelector("#menu-drawer");
    if (navigation && menuDrawer) { var h = navigation.scrollHeight; menuDrawer.style.height=h+"px"; menuDrawer.style.maxHeight=h+"px"; }
  }

  /* Footer accordion mobile */
  function initFooterAccordion() {
    if (window.innerWidth <= 768) {
      $(".footer-block__heading").off("click").on("click", function() {
        $(this).toggleClass("active").next(".list-unstyled").slideToggle().parent().siblings().find(".list-unstyled").slideUp().prev().removeClass("active");
      });
    } else {
      $(".footer-block__heading").off("click");
    }
  }
  initFooterAccordion();
  $(window).on("resize", initFooterAccordion);
});

/* ---- DESKTOP SLIDER HIDE BEFORE INIT ---- */
if (window.innerWidth > 768) {
  var style = document.createElement("style");
  style.textContent = ".new-coll-content.enable_slider_desktop:not(.slick-initialized){display:none}";
  document.head.appendChild(style);
}

/* ---- RIGHT CLICK PROTECTION ---- */
document.addEventListener("contextmenu", function(e) {
  if (e.target.tagName === "IMG") e.preventDefault();
});

/* ---- MEGA MENU HOVER (desktop) ---- */
document.addEventListener("DOMContentLoaded", function() {
  if (window.innerWidth < 990) return;
  document.querySelectorAll("details.mega-menu").forEach(function(menu) {
    var summary = menu.querySelector("summary");
    menu.addEventListener("mouseenter", function() { menu.setAttribute("open",true); summary.setAttribute("aria-expanded","true"); });
    menu.addEventListener("mouseleave", function() { menu.removeAttribute("open"); summary.setAttribute("aria-expanded","false"); });
    summary.addEventListener("click", function(e){ e.preventDefault(); });
  });
});

/* ================================================
   MAIN INIT — runs when jQuery + Slick are ready
   ================================================ */
function faborangeInit() {
  initSliders();
  initVideoModal();
}


  faborangeInit();

